/*
 *
 * UploadMedia reducer
 *
 */
import produce from 'immer';
import {
  UPLOAD_MEDIA_FILE,
  UPLOAD_MEDIA_FILE_SUCCESS,
  UPLOAD_MEDIA_FILE_ERROR,
  FLUSH_STATE,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  file: false,
  fileType: false,
  uploadedFile: false,
  currentFile: false,
};

/* eslint-disable default-case, no-param-reassign */
const uploadMediaReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case UPLOAD_MEDIA_FILE:
        draft.loading = true;
        draft.error = false;
        draft.uploadedFileType = false;
        draft.file = action.file;
        draft.fileType = action.fileType;
        break;

      case UPLOAD_MEDIA_FILE_SUCCESS:
        draft.uploadedFile = action.uploadedFile;
        draft.uploadedFileType = action.uploadedFileType;
        draft.loading = false;
        draft.currentFile = false;
        break;

      case UPLOAD_MEDIA_FILE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.uploadedFile = 'error';
        draft.uploadedFileType = false;
        break;
    }
  });

export default uploadMediaReducer;
